import { PlatformEnvironment } from './platform-environment.interface';
import { InjectionToken } from '@angular/core';
import { ChangelogEnvironment } from './changelog-environment.interface';
import { WebsocketEnvironment } from './websocket-environment.interface';
import { ApiEnvironment } from './api-environment.interface';
import { AppEnvironment } from './app-environment.interface';
import { AuthEnvironment } from './auth-environment.interface';
import { UiEnvironment } from './ui-environment.interface';
import { LoginEnvironment } from './login-environment.interface';
import { PortalEnvironment } from './portal-environment.interface';
import { MaintenanceEnvironment } from './maintenance-environment.interface';

export interface CommonsEnvironment {
  production: boolean;
  env: string;

  api: ApiEnvironment;
  app: AppEnvironment;
  auth?: AuthEnvironment;
  login?: LoginEnvironment;
  portal?: PortalEnvironment;
  ui?: UiEnvironment;
  platform?: PlatformEnvironment;
  changelog?: ChangelogEnvironment;
  websocket?: WebsocketEnvironment;
  maintenance?: MaintenanceEnvironment;

  links?: Record<string, string>;
}

export const COMMONS_ENVIRONMENT = new InjectionToken<CommonsEnvironment>(
  'COMMONS_ENVIRONMENT',
);
